// extracted by mini-css-extract-plugin
module.exports = {"logoMobile":"FooterLogo_logoMobile__iv5F6","logo":"FooterLogo_logo__akSdI","wrapper":"FooterLogo_wrapper__tPqyC"};